/* eslint-disable no-restricted-syntax */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-nested-ternary */
import React, { useCallback, useEffect, useState } from "react";
import { Typography, Grid, Link, Switch } from "@mui/material";
import {
  Edit as EditIcon,
  Save as SaveIcon,
  Close as CloseIcon,
  AccountCircle as AccountCircleIcon,
  CompassCalibration as CompassCalibrationIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import dealerInfo from "assets/supergasbras/images/dealerInfo.png";

import Input from "components/Input";

import { DealerSearchByIdResponse } from "store/modules/DealerCare/types.store";
import { useNavigate } from "react-router-dom";
import { formatPhoneByText, removeCaracterPhone } from "utils/formatByText";
import {
  handleDisableDealerRequest,
  handleEnableDealerRequest,
} from "store/modules/DealerCare/thunk.store";
import { useAppDispatch } from "store/hooks";
import ModalEnable from "../ModalEnable";

import * as Styled from "./styles";

import { useDealerInfo } from "./useDealerInfo";
import DealerServices from "../DealerServices";

interface DealerInfoProps {
  dealerTradeName: string;
  dealerEnabled: boolean;
  dealerId: string;
  dealerData: DealerSearchByIdResponse;
}

function DealerInfo({
  data,
  reload,
}: {
  data: DealerInfoProps;
  reload: () => Promise<void>;
}): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {
    errors,
    setValue,
    register,
    handleSubmitData,
    handleSubmit,
    handleChangeEditMode,
    editMode,
    isReload,
    setIsReload,
  } = useDealerInfo(data);

  const backPage = (index: number) => navigate(index);

  useEffect(() => {
    if (isReload) {
      reload();
      setIsReload(false);
    }
  }, [isReload]);

  const openProductsAndCoverage = () => {
    navigate(`/dealers/${data.dealerId}/products-and-coverage`, {
      state: {
        name: data.dealerTradeName,
        gasDoPovo: data.dealerData?.dealerInfo?.attributes?.gasDoPovo ?? false,
      },
    });
  };

  const [isOpenModalEnable, setIsOpenModalEnable] = useState(false);

  const handleEnableStatus = useCallback(
    async (isChecked: boolean) => {
      setIsOpenModalEnable(false);
      if (isChecked) {
        await dispatch(
          handleEnableDealerRequest({ dealerId: data.dealerId }),
        ).unwrap();
      } else {
        await dispatch(
          handleDisableDealerRequest({ dealerId: data.dealerId }),
        ).unwrap();
      }
      await reload();
    },
    [isOpenModalEnable],
  );

  const onChangeEnableDealer = ({
    target,
  }: React.ChangeEvent<HTMLInputElement>) => {
    if (!target.checked) {
      setIsOpenModalEnable(true);
    } else {
      handleEnableStatus(target.checked);
    }
  };

  const openUsers = () => {
    navigate(`/users/manage`, {
      state: {
        dealer: {
          id: data.dealerId,
          name: data.dealerTradeName,
        },
      },
    });
  };

  const phoneRemoveDDi = data?.dealerData?.dealerInfo?.whatsAppNumber?.replace(
    /^[ ]*55([\s\S]+)/,
    "$1",
  );

  return (
    <Styled.Container>
      <Styled.TopContainer>
        <Styled.TopLeftContainer>
          <Styled.Image src={dealerInfo} />
        </Styled.TopLeftContainer>
        <Styled.ContainerFlex>
          <Styled.TopLeftContainer>
            <Styled.BreadcrumbsContainer aria-label="breadcrumb">
              <div>
                <Link
                  underline="hover"
                  color="inherit"
                  onClick={() => backPage(-1)}
                >
                  {t("dealers")} / {data.dealerTradeName} /
                </Link>
                <Typography color="text.primary" variant="h5">
                  {t("dealerInformations")}
                </Typography>
              </div>
            </Styled.BreadcrumbsContainer>
          </Styled.TopLeftContainer>
          <Styled.TopRightContainer>
            <Styled.PillContainer isOpen={data.dealerEnabled}>
              <Typography color={data.dealerEnabled ? "success.main" : "error"}>
                {data.dealerEnabled ? t("openDealer") : t("closedDealer")}
                <Switch
                  checked={data.dealerEnabled}
                  color="success"
                  onChange={onChangeEnableDealer}
                />
              </Typography>
            </Styled.PillContainer>
          </Styled.TopRightContainer>
        </Styled.ContainerFlex>
      </Styled.TopContainer>

      <Grid container mt={3}>
        {editMode ? (
          <div style={{ width: "100%" }}>
            <Styled.ContainerPhone>
              <Styled.ContainerInfo>
                <Typography color="text.primary" variant="body2">
                  Pedidos pelo WhatsApp
                </Typography>
              </Styled.ContainerInfo>

              <Styled.ContainerNotRegister>
                <Typography
                  color={
                    data?.dealerData?.dealerInfo?.whatsAppNumber?.length
                      ? "green"
                      : "text.primary"
                  }
                  variant="subtitle1"
                >
                  {data?.dealerData?.dealerInfo?.whatsAppNumber?.length
                    ? "WhatsApp cadastrado"
                    : "WhatsApp não cadastrado"}
                </Typography>
              </Styled.ContainerNotRegister>
            </Styled.ContainerPhone>
            <Input
              name="phone"
              error={errors.phone}
              label="Número responsável"
              placeholder="(99) 99999-9999"
              register={register}
              defaultValue={
                phoneRemoveDDi?.length === 11
                  ? formatPhoneByText(phoneRemoveDDi || "")
                  : phoneRemoveDDi || ""
              }
              fullWidth
              registerOptions={{
                onChange: (e) =>
                  setValue("phone", removeCaracterPhone(e.target.value)),
              }}
              sx={{ mb: 2 }}
              inputProps={{
                maxLength: 20,
              }}
            />
            <div style={{ paddingBottom: "50px" }}>
              <Typography color="light" fontSize={14} variant="body1">
                Para receber seus pedidos pelo WhatsApp, basta salvar um número
                válido.
                <br /> Se não quiser mais receber notificações, remova o número.
              </Typography>
            </div>
            {data.dealerTradeName && (
              <Grid item sm={12} md={12} xs={12}>
                <Input
                  name="tradeName"
                  error={errors.tradeName}
                  defaultValue={data.dealerTradeName}
                  label={t("dealerNameInApp")}
                  placeholder="Supergasbras"
                  register={register}
                  fullWidth
                  disabled
                  sx={{ mb: 2 }}
                />
              </Grid>
            )}
          </div>
        ) : (
          <Grid item sm={12} md={12} xs={12}>
            <Typography mb={3} variant="h5">
              {data.dealerTradeName}
            </Typography>
            <Styled.ContainerPhone>
              <Styled.ContainerInfo>
                <Typography color="text.primary" variant="body2">
                  Pedidos pelo WhatsApp
                </Typography>

                <Typography color="text.primary" variant="subtitle1">
                  {phoneRemoveDDi?.length
                    ? phoneRemoveDDi?.length === 11
                      ? formatPhoneByText(phoneRemoveDDi || "")
                      : phoneRemoveDDi
                    : "WhatsApp não cadastrado"}
                </Typography>
              </Styled.ContainerInfo>

              <Styled.ContainerNotRegister
                style={{
                  border: data?.dealerData?.dealerInfo?.whatsAppNumber
                    ? "1px solid green"
                    : "1px solid #000000",
                }}
              >
                <Typography
                  color={
                    data.dealerData?.dealerInfo.whatsAppNumber
                      ? "green"
                      : "text.primary"
                  }
                  variant="subtitle1"
                >
                  {data.dealerData?.dealerInfo.whatsAppNumber
                    ? "WhatsApp cadastrado"
                    : "WhatsApp não cadastrado"}
                </Typography>
              </Styled.ContainerNotRegister>
            </Styled.ContainerPhone>

            <DealerServices
              dealerId={data.dealerId}
              dealerData={data.dealerData}
              reload={reload}
            />
          </Grid>
        )}
      </Grid>
      <Styled.ActionsContainer>
        {editMode ? (
          <>
            <Styled.ButtonSecondary
              onClick={handleChangeEditMode}
              color="inherit"
              variant="text"
              endIcon={<CloseIcon />}
              sx={{
                marginRight: 1,
              }}
            >
              {t("close")}
            </Styled.ButtonSecondary>
            <Styled.ButtonIcon
              onClick={handleSubmit(handleSubmitData)}
              color="inherit"
              variant="text"
              endIcon={<SaveIcon />}
            >
              {t("save")}
            </Styled.ButtonIcon>
          </>
        ) : (
          <>
            <Styled.ButtonIcon
              onClick={openUsers}
              color="inherit"
              variant="text"
              endIcon={<AccountCircleIcon />}
              sx={{
                marginRight: 1,
              }}
            >
              {t("manageUsers")}
            </Styled.ButtonIcon>
            <Styled.ButtonIcon
              onClick={openProductsAndCoverage}
              color="inherit"
              variant="text"
              endIcon={<CompassCalibrationIcon />}
              sx={{
                marginRight: 1,
              }}
            >
              {t("productsAndCoverage")}
            </Styled.ButtonIcon>

            <Styled.ButtonIcon
              onClick={handleChangeEditMode}
              color="inherit"
              variant="text"
              endIcon={<EditIcon />}
            >
              {t("edit")}
            </Styled.ButtonIcon>
          </>
        )}
      </Styled.ActionsContainer>
      <ModalEnable
        isOpen={isOpenModalEnable}
        onNo={() => setIsOpenModalEnable(!isOpenModalEnable)}
        onYes={() => handleEnableStatus(!data.dealerEnabled)}
      />
    </Styled.Container>
  );
}

export default DealerInfo;
